import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../../assets/css/mainMenu.css";
import "../../../assets/css/addunit.css";

import edit from "../../../assets/icons/edit.svg";
import close from "../../../assets/icons/close.svg";
import ArrowDown from "../../../assets/icons2/ArrowDown.svg";
import trash from "../../../assets/icons/trash.svg";
import ArrowUp from "../../../assets/icons2/ArrowUp.svg";
import plus1 from "../../../assets/icons/plus1.svg";
import search2 from "../../../assets/icons/search2.svg";
import fetchWrapper from "./../../../AuthMiddleware/FetchWrapper";
import Loader from "../../../Components/LoaderAndSpinner/Loader";
import Pagination from "../../../Components/Pagination/Pagination";
import { hasPermission } from "../../../Services/authUtils";

const AssetList = () => {
  const [loading, setLoading] = useState(false);
  const [assetList, setAssetList] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [actionAssetId, setActionAssetId] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState({
    field: "created_at",
    order: "asc",
  });
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const startIndex = (page - 1) * pageSize + 1;
  const endIndex = Math.min(page * pageSize, totalItems);

  const navigate = useNavigate();
  const { id } = useParams();

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior if needed
      fetchAssets(); // Perform search
    }
  };
  useEffect(() => {
    fetchAssets();
  }, [
    id,
    page,
    pageSize,
    sortBy,
    // search,
    totalPages,
    currentPage,
    totalItems,
    confirmModal,
  ]);

  const fetchAssets = async () => {
    const queryString = `?page=${page}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}&search=${search}`;
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset/paginate${queryString}`;

    try {
      const data = await fetchWrapper(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      setAssetList(data.assets);
      setTotalPages(data.totalPages);
      setTotalItems(data.totalItems);
      setCurrentPage(data.currentPage);
    } catch (error) {
      console.error("Error fetching asset Lists:", error);
      toast.error("Error fetching asset Lists");
      // Optionally handle navigation on error
      if (error.message === "Unauthorized") {
        navigate("/auth/login");
      }
    }
  };

  const handleSortChange = (field) => {
    setSortBy((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  const handleToggleUserStatus = (assetId) => {
    setActionAssetId(assetId);
    setConfirmModal(true);
  };

  const confirmAction = async () => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset/delete/${actionAssetId}`;

    try {
      await fetchWrapper(url, {
        method: "POST",
      });

      setLoading(false);
      setConfirmModal(false);
      toast.success("Asset Class Delete Successful");
    } catch (error) {
      setLoading(false);
      console.log(error.message)
      if (error.message.includes("Cannot delete the asset.")) {
        toast.error(error.message);
      }
      else {
        toast.error(`something went wrong`);
      }
      // Optionally handle navigation on error
      if (error.message === "Unauthorized") {
        navigate("/auth/login");
      }
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setPage(page);
      // Add any additional logic for page change here
    }
  };

  // Calculate the page numbers to display

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPage(1);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <div className="container">
            <div className="show-breadcrumb pt-3">
              <div className="">
                <h5>Asset Class</h5>

                <nav className="breadcrumb-nav" aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a className="">Assets</a>
                    </li>

                    <li className="breadcrumb-item active" aria-current="page">
                      Asset Class
                    </li>
                  </ol>
                </nav>
                <div className="">
                  <div
                    className="navbar-3 d-flex justify-content-between"
                    style={{ marginTop: "-3px" }}
                  >
                    <div className="search-container ">
                      <img src={search2} alt="Search" />
                      <input
                        type="text"
                        className=""
                        id="search"
                        value={search}
                        onChange={handleSearchChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Search "
                      />
                    </div>

                    {hasPermission(["assets.create"]) && (
                      <div className="">
                        <button
                          type="button"
                          id="openPopup"
                          className="btn-bg"
                          onClick={() => navigate(`/asset_class/create`)}
                        >
                          <span className="plus-icon">
                            <img src={plus1} alt="Plus Icon" />
                          </span>
                          CREATE NEW ASSET CLASS
                        </button>
                      </div>
                    )}
                  </div>
                  <div style={{ marginTop: "-10px" }}>
                    <div className="table-responsive">
                      <table className="table  align-middle table-text">
                        <thead className="table-head align-middle">
                          <tr>
                            {/* <th className="table-check">
                              <input type="checkbox" />
                            </th> */}
                            <th>ID</th>
                            <th
                              className="col text-uppercase"
                              onClick={() => handleSortChange("asset_code")}
                            >
                              Asset Class Code{" "}
                              {sortBy.field === "asset_code" && (
                                <span>
                                  {sortBy.order === "asc" ? (
                                    <img src={ArrowUp} alt="ArrowUp" />
                                  ) : (
                                    <img src={ArrowDown} alt="ArrowDown" />
                                  )}
                                </span>
                              )}
                            </th>
                            <th
                              className="col text-uppercase"
                              onClick={() => handleSortChange("asset_name")}
                            >
                              Asset Class Name{" "}
                              {sortBy.field === "asset_name" && (
                                <span>
                                  {sortBy.order === "asc" ? (
                                    <img src={ArrowUp} alt="ArrowUp" />
                                  ) : (
                                    <img src={ArrowDown} alt="ArrowDown" />
                                  )}
                                </span>
                              )}
                            </th>
                            <th className="col text-uppercase">
                              Attributes Status
                            </th>
                            <th className="col text-uppercase">
                              Configure Status
                            </th>

                            {(hasPermission(["assets.update"]) ||
                              hasPermission(["assets.delete"])) && (
                                <th className="col-2 text-uppercase">ACTION</th>
                              )}
                          </tr>
                        </thead>
                        <tbody className="pl-4">
                          {assetList.map((asset, id1) => (
                            <tr key={asset._id}>
                              {/* <td className="table-check">
                                <input type="checkbox" />
                              </td> */}
                              <td>{id1 + startIndex}</td>
                              <td className="col">{asset.asset_code}</td>
                              <td className="col">{asset.asset_name}</td>
                              <td className="col">{asset.attribute_status ? 'True' : 'False'}</td>
                              <td className="col">{asset.configure_status ? 'True' : 'False'}</td>

                              {(hasPermission(["assets.update"]) ||
                                hasPermission(["assets.delete"])) && (
                                  <td>
                                    <div className="action-icons d-flex justify-content-left align-items-center ">
                                      {hasPermission(["assets.update"]) && (
                                        <button
                                          style={{
                                            border: "none",
                                            backgroundColor: "transparent",
                                          }}
                                          className="align-content-center me-3"
                                          onClick={() =>
                                            navigate(`/asset/edit/${asset._id}`)
                                          }
                                        >
                                          <img src={edit} alt="edit" />
                                        </button>
                                      )}

                                      {hasPermission(["assets.delete"]) && (
                                        <button
                                          style={{
                                            border: "none",
                                            backgroundColor: "transparent",
                                          }}
                                          className="align-content-center"
                                          onClick={() =>
                                            handleToggleUserStatus(asset._id)
                                          }
                                        >
                                          <img src={trash} alt="trash" />
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    pageSize={pageSize}
                    onPageSizeChange={handlePageSizeChange}
                    totalItems={totalItems}
                    startIndex={startIndex}
                    endIndex={endIndex}
                  />
                </div>
              </div>
            </div>

            {/* Confirmation Modal */}
            <div
              id="overlay"
              className={`modal fade ${confirmModal ? "show" : ""}`}
              tabIndex="-1"
              role="dialog"
              style={{
                zIndex: 30,
                display: confirmModal ? "block" : "none",
                transition: "width 2s",
              }}
            >
              <div>
                <div className="addunit-card Width 25%">
                  <div className="addunit-header">
                    <h4>Delete asset</h4>
                    <button
                      style={{ border: "none", backgroundColor: "inherit" }}
                      type="button"
                      className="close"
                      onClick={() => setConfirmModal(false)}
                    >
                      <img src={close} width="28px" height="28px" alt="Close" />
                    </button>
                  </div>
                  <div className="addunit-form">
                    <p>Are you sure you want to delete this asset?</p>
                  </div>
                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => setConfirmModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="update-btn"
                      onClick={confirmAction}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer autoClose={2000} position={"top-right"} />
    </>
  );
};

export default AssetList;
